import Typography from '@mui/material/Typography';
import { SocialIcon } from 'react-social-icons';
export default function DefaultFooter() {
    return (
        <>
            <footer className="relative bg-gray-100 pt-8 pb-6">
                <div className="container max-w-7xl mx-auto px-4">
                    <div className="flex flex-wrap text-center lg:text-left pt-6">
                        <div className="w-full lg:w-6/12 px-4">
                            <Typography variant="h4" color="text.secondary">ZippyOPS</Typography>
                            <div className="-mt-4">
                                <Typography variant="body1" color="text.secondary">
                                Making Automation Work
                                </Typography>
                            </div>
                            <div className="flex gap-2 mt-6 md:justify-start md:mb-0 mb-8 justify-center">
                            <SocialIcon target="blank" url="https://twitter.com/ZippyOps" network="twitter" fgColor="#fff" style={{ height: 35, width: 35 }} />
                            <SocialIcon target="blank" url="https://facebook.com/zippyops" network="facebook" fgColor="#fff" style={{ marginLeft: '1em', height: 35, width: 35 }} />
                            <SocialIcon target="blank" url="https://instagram.com/zippyops" network="instagram" fgColor="#fff" style={{ marginLeft: '1em', height: 35, width: 35 }} />
                            <SocialIcon target="blank" url="https://youtube.com/channel/UCZh2aijMM-h6ztRo36m3CiQ" network="youtube" fgColor="#fff" style={{ marginLeft: '1em', height: 35, width: 35 }} />
                            <SocialIcon target="blank" url="https://linkedin.com/in/zippyops" network="linkedin" fgColor="#fff" style={{ marginLeft: '1em', height: 35, width: 35 }} />
                            <SocialIcon target="blank" url="https://t.me/ZippyOPS" network="telegram" fgColor="#fff" style={{ marginLeft: '1em', height: 35, width: 35 }}/>
                            </div>
                        </div>
                        <div className="w-full lg:w-6/12 px-4">
                            <div className="flex flex-wrap items-top">
                                <div className="w-full lg:w-4/12 px-4 ml-auto md:mb-0 mb-8">
                                    <span className="block uppercase text-gray-900 text-sm font-serif font-medium mb-2">
                                      Menu
                                    </span>
                                    <ul className="list-unstyled">
                                        <li>
                                            <a
                                                href="https://www.zippyops.com/blog"
                                                target="_blank"
                                                rel="noreferrer"
                                                className="text-gray-700 hover:text-gray-900 block pb-2 text-sm"
                                            >
                                                Blog
                                            </a>
                                        </li>
                                        <li>
                                            <a
                                                className="text-gray-700 hover:text-gray-900 block pb-2 text-sm"
                                                target="_blank"
                                                href="https://www.zippyops.com/services"
                                            >
                                                Services
                                            </a>
                                        </li>
                                        <li>
                                            <a
                                                href="https://www.zippyops.com/about-us"
                                                target="_blank"
                                                rel="noreferrer"
                                                className="text-gray-700 hover:text-gray-900 block pb-2 text-sm"
                                            >
                                                About us
                                            </a>
                                        </li>
                                        <li>
                                            <a
                                                href="https://www.zippyops.com/products"
                                                target="_blank"
                                                rel="noreferrer"
                                                className="text-gray-700 hover:text-gray-900 block pb-2 text-sm"
                                            >
                                                Products
                                            </a>
                                        </li>
                                    </ul>
                                </div>
                                <div className="w-full lg:w-4/12 px-4">
                                    <span className="block uppercase text-gray-900 text-sm font-serif font-medium mb-2">
                                        Blog
                                    </span>
                                    <ul className="list-unstyled">
                                        <li>
                                            <a
                                                href="https://www.zippyops.com/blog/infrastructure"
                                                target="_blank"
                                                rel="noreferrer"
                                                className="text-gray-700 hover:text-gray-900 block pb-2 text-sm"
                                            >
                                                Infrastructure
                                            </a>
                                        </li>
                                        <li>
                                            <a
                                                href="https://www.zippyops.com/blog/devsecops"
                                                target="_blank"
                                                rel="noreferrer"
                                                className="text-gray-700 hover:text-gray-900 block pb-2 text-sm"
                                            >
                                                DevSecOps
                                            </a>
                                        </li>
                                        <li>
                                            <a
                                                href="https://www.zippyops.com/blog/devops"
                                                target="_blank"
                                                rel="noreferrer"
                                                className="text-gray-700 hover:text-gray-900 block pb-2 text-sm"
                                            >
                                                DevOps
                                            </a>
                                        </li>
                                        <li>
                                            <a
                                                href="zippyops.com/blog/AutomatedOPS"
                                                target="_blank"
                                                rel="noreferrer"
                                                className="text-gray-700 hover:text-gray-900 block pb-2 text-sm"
                                            >
                                                AutomatedOPS
                                            </a>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </footer>
        </>
    );
}
